/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Case_Create_Incomplete_Confirm_IntroInputs */

const en_case_create_incomplete_confirm_intro = /** @type {(inputs: Case_Create_Incomplete_Confirm_IntroInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`A task will be created for staff to complete the following later:`)
};

const pt_br2_case_create_incomplete_confirm_intro = /** @type {(inputs: Case_Create_Incomplete_Confirm_IntroInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Uma tarefa será criada para a equipe completar depois o que está faltando:`)
};

/**
* | output |
* | --- |
* | "A task will be created for staff to complete the following later:" |
*
* @param {Case_Create_Incomplete_Confirm_IntroInputs} inputs
* @param {{ locale?: "en" | "pt-BR" }} options
* @returns {LocalizedString}
*/
export const case_create_incomplete_confirm_intro = /** @type {((inputs?: Case_Create_Incomplete_Confirm_IntroInputs, options?: { locale?: "en" | "pt-BR" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Case_Create_Incomplete_Confirm_IntroInputs, { locale?: "en" | "pt-BR" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_case_create_incomplete_confirm_intro(inputs)
	return pt_br2_case_create_incomplete_confirm_intro(inputs)
});